import {
    GridColDef,
    GridDataSource, GridFilterItem, GridFilterModel,
    GridGetRowsError, GridRenderCellParams,
    GridUpdateRowError,
} from '@mui/x-data-grid-pro'
import AllCellComponentsSpecialProps from 'app/Apps/DomainObject/ComponentMapper'
import {
    SkyNetPaginationType,
} from 'app/shared-components/SkyNetPagination'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import {
    FilterType,
} from 'app/enums/common.enums'
import {
    RequestConfig,
} from 'app/types/request.types'

/* new Filters types that will be supported only in new Tables */
export enum SkyNetDataGridFilterType {
    Boolean = 'boolean',
    Toggle = 'toggle',
}

export type ExtendedFilterType = FilterType | SkyNetDataGridFilterType

type RenderCellProp =
    { renderCell?: (props: GridRenderCellParams) => JSX.Element } | AllCellComponentsSpecialProps

/* Type to convert SkyNetTableFieldBase config to MUI GridColDef
    SkyNetTableFieldBase -> MUI GridColDef
        sorting          ->    sortable
        name             ->    field
        componentName    ->    renderCell
*/
export type ColumnConfigMappingType<T = any> = {
    sorting?: boolean,
    labelKey?: string,
    name: keyof T,
    minWidth?: number,
    filterType?: ExtendedFilterType,
    /* if true - column wouldn't be visible but will be added to FilterMenu */
    hiddenFromColumns?: boolean,
    headerName?: string,
    reduced?: boolean,
} & RenderCellProp

/*  DataSource for DataGrid with Error handling */
export type SkyNetDataSourceProvider = {
    dataSource: GridDataSource,
    onDataSourceError: (rowsError: (GridGetRowsError | GridUpdateRowError)) => void,
    errorMessage?: string,
    paginationOptions?: SkyNetPaginationType,
    showArchived?: boolean,
    isFetching?: boolean,
    key?: RequestKeys | string
    request: RequestConfig,
    invalidate: () => void,
}

/* Our custom filterOperators keys for FilterModer */
export enum FilterOperatorType {
    EqualsIncludeFilter = 'equalsIncludeFilter', // for includeFilters
    // for other filters that will be added to request body , like { archived: true }
    DataFilter = 'dataFilter',
}

export type ExtendedGridColDef = GridColDef & ColumnConfigMappingType

export type ExtendedGridFilterItem = GridFilterItem & {
    defaultValue: string,
}
export type ExtendedGridFilterModel = GridFilterModel & {
    items: ExtendedGridFilterItem[]
}
